// TODO: Support different environments (local, dev, production)
export const BASE_API_URL = "https://pub.api.muun.io"
export const FEE_ESTIMATOR_LANDING_CSV_URL = `${BASE_API_URL}/fee-estimator/public/landing/`

export const ACCOUNT_DELETION_URL = `${BASE_API_URL}/houston/user/email/account-deletion/initiate`